const OnlineBadge = (
  <div
    style={{
      background: "#00c853",
      border: "solid 2px white",
      height: "14px",
      width: "14px",
      borderRadius: "14px",
      position: "absolute",
      bottom: "2px",
      right: "2px",
      zIndex: 1,
    }}
  />
);

const PremiumBadge = (
  <svg
    id="badge"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 29.549 29.552"
    style={{
      marginLeft: "6px",
      marginBottom: "-1px",
    }}
  >
    <ellipse
      id="Ellipse_229"
      data-name="Ellipse 229"
      cx="14.774"
      cy="14.775"
      rx="14.774"
      ry="14.775"
      transform="translate(0 0.001)"
      fill="#fff"
    />
    <path
      id="Subtraction_1"
      data-name="Subtraction 1"
      d="M14.774,29.552A14.771,14.771,0,0,1,0,15.045H1.176c1.659,0,4.327,0,5.523,0a1.171,1.171,0,0,0,.972-.484c.206-.262.431-.516.648-.76.068-.08.134-.156.2-.232.024-.028.047-.056.079-.056a.068.068,0,0,1,.027.007c.042.017.035.053.028.087a.133.133,0,0,1,0,.024c-.095.589-.72,5.259-.774,5.895l-.011.152,0,.017a8.5,8.5,0,0,0-.047,1.206,1.767,1.767,0,0,0,.3,1.062,1.048,1.048,0,0,0,.316.263,1.013,1.013,0,0,0,.4.114c.031,0,.061,0,.091,0a1.031,1.031,0,0,0,.672-.264,3.54,3.54,0,0,0,.691-1c.5-.943,4.294-9.579,4.48-10.014a.772.772,0,0,1,.062-.123l.007-.015c.009-.014.016-.024.023-.036a.015.015,0,0,0,0-.009.041.041,0,0,1,.007-.009c.011-.026.027-.053.056-.053a.072.072,0,0,1,.027.005c.043.02.041.068.034.113s-.095.572-.21,1.249c-.347,2.049-.812,4.806-.825,5.08l-.005.051v.053a1.943,1.943,0,0,0,.157,1.127A1.136,1.136,0,0,0,15,19.1a1.867,1.867,0,0,0,.268.02,2.009,2.009,0,0,0,.339-.03,1.392,1.392,0,0,0,.855-.547,5.2,5.2,0,0,0,.7-1.238c.043-.111,1.065-2.373,1.833-4.065.713-1.582,1.358-3.01,1.4-3.121a.515.515,0,0,1,.117-.2h.03a.072.072,0,0,1,.03.019.52.52,0,0,1-.02.285l-.005.014a.63.63,0,0,0-.02.087c-.1.4-.383,1.514-.713,2.8-.553,2.155-1.478,5.763-1.661,6.694a5.264,5.264,0,0,0-.119.988,1.4,1.4,0,0,0,1.051,1.476,2.573,2.573,0,0,0,.53.064,1.8,1.8,0,0,0,1.2-.446,3.141,3.141,0,0,0,.519-.635c.18-.265,1.092-1.914,1.9-3.368l.079-.139.058-.108c.6-1.089,1.173-2.117,1.3-2.323a.35.35,0,0,0,.034-.057l0-.005c.034-.062.065-.12.146-.138a.485.485,0,0,1,.142-.017h4.547A14.773,14.773,0,0,1,14.774,29.552Zm5.443-10.089h-.005a.01.01,0,0,0-.007,0c-.051-.01-.047-.051-.042-.09a2.1,2.1,0,0,1,.045-.209.052.052,0,0,0,0-.015l2.184-8.642c0-.005.271-1.229.356-1.869a4.774,4.774,0,0,0,.05-1.087,1.416,1.416,0,0,0-1.22-1.343,2.015,2.015,0,0,0-.282-.02,1.769,1.769,0,0,0-1.146.425,1.837,1.837,0,0,0-.428.543c-.37.677-.984,2.117-.991,2.128s-.447,1-.955,2.133c-.6,1.351-1.293,2.884-1.356,3.022-.023.043-.041.069-.079.078h0a.071.071,0,0,1-.03-.01.055.055,0,0,1-.024-.019.2.2,0,0,1,0-.168l.009-.037,0-.014c.081-.464.328-1.926.505-2.994.125-.728.221-1.3.224-1.316s.092-.792.146-1.16a8.215,8.215,0,0,0,.081-.841,2.961,2.961,0,0,0-.088-1.036,1.1,1.1,0,0,0-1.06-.82,1.28,1.28,0,0,0-.694.213,2.6,2.6,0,0,0-.848.94c-.363.629-.988,1.938-.993,1.946s-.058.137-.153.352c-1.986,4.492-3.066,6.935-3.215,7.257a.073.073,0,0,0-.009.034c-.011.029-.018.059-.047.059a.05.05,0,0,1-.024,0c-.075-.019-.066-.083-.057-.141.034-.163.22-1.38.461-2.955.207-1.356.411-2.673.485-3.12.007-.058.018-.114.027-.168l.007-.041c.011-.069.023-.14.034-.212a.825.825,0,0,0-.18-.621.9.9,0,0,0-.722-.386,1.246,1.246,0,0,0-.383.068.9.9,0,0,0-.4.314c-.309.36-.637.749-1,1.188-.192.226-.5.583-.855,1.006l-.154.178c-.2.244-.465.545-.7.84a1.2,1.2,0,0,1-.092.1,1.215,1.215,0,0,0-.108.123.22.22,0,0,1-.161.073H6.186l-3.346,0H2.589l-2.5,0a14.774,14.774,0,0,1,29.381.117H24.453a2.722,2.722,0,0,0-.341.02.857.857,0,0,0-.672.444c-.539.936-2.554,4.562-3.031,5.449-.015.028-.034.056-.051.083l-.007.012a.77.77,0,0,0-.072.139C20.261,19.437,20.245,19.463,20.217,19.463Z"
      transform="translate(0.003 0)"
      fill="#1565c0"
    />
  </svg>
);

export { OnlineBadge, PremiumBadge };
